import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import {Provider} from "react-redux";
import moment from "moment";

import {ThemeProvider} from "@mui/material";

import { store } from './store'
import Main from './pages/main/Main';
import Agreement from './pages/agreement/Agreement';
import BlogPage from "./pages/blog-page/BlogPage";
import Blog from "./pages/blog/Blog";

import MUI_THEME from "./mui_theme";
import "./config/i18";
import 'moment/locale/ru';

import './index.scss';
import Partners from "./pages/partners/main/Partners";

moment.locale('ru');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <ThemeProvider theme={MUI_THEME}>
          <Provider store={store}>
              <BrowserRouter>
                  <Routes>
                      <Route path="/" element={<Main />}/>
                      <Route path="/agreement" element={<Agreement />} />
                      <Route path="/blog" element={<Blog />} />
                      <Route path="/blog/:slug" element={<BlogPage />} />
                      <Route path="/partners" element={<Navigate to="/partners/transport" replace />} />
                      <Route path="/partners/transport" element={<Partners />} />
                      <Route path="/partners/cert-centers" element={<Partners variant="cert-centers" />} />
                      <Route path="/en/partners" element={<Navigate to="/en/partners/transport" replace />} />
                      <Route path="/en/partners/transport" element={<Partners />} />
                      <Route path="*" element={<Main />} />
                  </Routes>
              </BrowserRouter>
          </Provider>
      </ThemeProvider>
  </React.StrictMode>
);
